<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>My Trusted Services</h4>
      <p>Trusted service's valid users will be treated as the trusting service's valid user in all RBAC scenarios. Subscriptions associated with the trusted service can be bound to the trusting service's execution plans as if they were associated with the trusting service.</p>
    </div>
    <div class="action-container">
      <button type="submit" class="btn btn-danger me-1" (click)="deleteTrustedService()" [disabled]="!isDeletable()">Delete Trusted Service</button>
      <button type="submit" class="btn btn-primary me-1" (click)="showAddingNewTrustedServiceDialog()" [disabled]="!isAddable">Add Trusted Service</button>
      <a
          href="javascript:void(0)"
          class="topbar-item"
          (click)="exportExcel()"
          placement="top-right"
          container="body"
          ngbTooltip="Export to Excel"
          aria-label="Export to Excel"
        >
          <span class="far fa-file-excel fa-lg"></span>
        </a>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main mt-3">
    <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
    <ag-grid-angular
      #agGrid
      id="ViewGrid"
      style="width: 100%; height: 540px"
      class="ag-theme-balham"
      [masterDetail]="true"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [excelStyles]="headerStyle"
      [pagination]="true"
      (selectionChanged)="onSelectionChanged($event)"
      (gridReady)="onGridReady($event)"
      (filterChanged)="onFilterChanged($event)"
    >
    </ag-grid-angular>
  </div>
</div>
